import { ENTITY_DEPARTMENT, ENTITY_TEAM, ENTITY_USER } from './schemas';

export const SPACE_OPUS_U = 'opus-u';
export const SPACE_USER = 'user-space';
export const SPACE_TEAM = 'team-space';
export const SPACE_DEPARTMENT = 'department-space';

export const SPACE_TYPE_ENTITY_MAP = {
  [SPACE_OPUS_U]: ENTITY_USER,
  [SPACE_USER]: ENTITY_USER,
  [SPACE_TEAM]: ENTITY_TEAM,
  [SPACE_DEPARTMENT]: ENTITY_DEPARTMENT,
};
